function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { PRINTER_DRIVER_TYPE } from "@dpdgroupuk/mydpd-enums";
import AbstractPrinterDriver from "./AbstractPrinterDriver";
import PrinterError, { STATUS_CODE } from "./PrinterError";

class UsbWebDeviceThermalDriver extends AbstractPrinterDriver {
  constructor(printer) {
    super(printer);
    this.device = null;
  }

  async configure() {
    const {
      thermalPrinterVendorId,
      thermalPrinterProductId
    } = this.printer.config;

    if (thermalPrinterVendorId && thermalPrinterProductId) {
      // get previously authorized devices
      const authDevices = await navigator.usb.getDevices();
      this.device = authDevices.find(({
        vendorId,
        productId
      }) => vendorId === thermalPrinterVendorId && productId === thermalPrinterProductId);

      if (!this.device) {
        throw new PrinterError("Thermal Printer configured to use WebUSB API but not paired", STATUS_CODE.WEB_USB_NOT_PAIRED);
      }

      return this._setup();
    } else {
      throw new PrinterError("Thermal Printer is not configured to use WebUSB API", STATUS_CODE.WEB_USB_NOT_REQUESTED);
    }
  }

  async pairDevice() {
    const {
      thermalPrinterVendorId,
      thermalPrinterProductId
    } = this.printer.config;
    this.device = await navigator.usb.requestDevice({
      filters: [{
        vendorId: thermalPrinterVendorId,
        productId: thermalPrinterProductId
      }]
    });
    return this._setup();
  }

  async _setup() {
    await this.device.open();

    if (this.device.configuration === null) {
      await this.device.selectConfiguration(1);
    }

    await this.device.claimInterface(0);
  }

  async print(labels) {
    if (!this.device) {
      throw new PrinterError("Thermal Printer configured to use WebUSB API but not paired", STATUS_CODE.WEB_USB_NOT_PAIRED);
    }

    if (!this.device.opened) {
      await this._setup();
    }

    const data = new TextEncoder().encode(labels);
    await this.device.transferOut(1, data);
  }

}

_defineProperty(UsbWebDeviceThermalDriver, "DRIVER_TYPE", PRINTER_DRIVER_TYPE.WEB_USB);

export default UsbWebDeviceThermalDriver;